<template>
  <section class="course-listing-section">
    <b-container>
      <div class="d-flex">
        <h4 class="title text-left" v-if="showHeading">
          Popular {{ course_name }} Courses
        </h4>

        <p v-if="showHeading" class="see-all ">
          <b-link
            :to="{
              path: '/all_courses',
              query: {
                course_name: course_name,
                category_id: categoryId
              }
            }"
            >See All
          </b-link>
        </p>
      </div>
      <b-row>
        <b-col
          cols="12"
          md="6"
          lg="3"
          v-for="i in course_count"
          :key="'course' + i"
        >
          <course-template
            v-if="courseArray.length > 0"
            :courseData="courseArray[i - 1]"
          />
          <ContentLoader v-else :height="450"> </ContentLoader>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import CourseTemplate from "../Templates/CourseTemplate";
import { ContentLoader } from "vue-content-loader";
import NoContent from "../Templates/NoContent";

export default {
  name: "Course-listing-view",
  components: {
    NoContent,
    CourseTemplate,
    ContentLoader
  },
  data() {
    return {
      courseData: []
    };
  },
  props: {
    course_name: String,
    courseArray: Array,
    course_count: {
      type: Number,
      default: 4
    },
    showHeading: {
      type: Boolean,
      default: true
    },
    categoryId: String
  },
  mounted() {}
};
</script>

<style></style>
